/**
 * Browser-only entry for reopening the Klaro modal.
 * Uses dynamic import so Klaro is not pulled into the prerender bundle (Footer/Layout/PrivacyPolicy).
 */
export function openCookiePreferences(): void {
  if (typeof window === 'undefined') return;

  void import('./cookieConsent').then(({ initializeCookieConsent, showCookiePreferences }) => {
    initializeCookieConsent();
    showCookiePreferences();
  });
}
